module.exports = {"id":"194964","name":"Nathaniel Mendez-Laing","rating":"71","photo":"./data/images/photos/3/194964.png","club":{"name":"Cardiff City","logo":"./data/images/clubs/CardiffCity.png"},"positions":["AD","MD","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NathanielMendez-Laing0.json
// module id = 3144
// module chunks = 0